import { underscore } from '@ember/string';
import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
import UUID from 'uuid-js';
export default BaseFragmentSerializer.extend({
  keyForRelationship(key) {
    return underscore(key);
  },
  normalize(type, payload) {
    const newPayload = {
      ...payload
    };
    newPayload.id = UUID.create().toString();
    return this._super(type, newPayload);
  },
  serialize(snapshot) {
    return this._super(snapshot, {
      includeId: false
    });
  }
});